'use-client';

import { ReactNode } from 'react';

interface IntroCardProps {
	titleIcon?: ReactNode;
	title: string;
	subtitle?: ReactNode;
	content?: ReactNode;
}

export const IntroCard = (props: IntroCardProps) => {
	const { title, subtitle, content, titleIcon } = props;

	return (
		<div className="flex flex-col gap-4 rounded-lg bg-white p-4">
			<div className="flex flex-row justify-between">
				<div className="flex-1 font-bold text-gray-900">
					<span className="mr-1">{titleIcon}</span>
					{title}
				</div>
				<div className="flex-1">{subtitle}</div>
			</div>
			<div className="flex h-full">{content}</div>
		</div>
	);
};
